import { memo } from 'react'

export default memo(({ condition, children }) => (condition ? children : null))
